export class StepType {
    static readonly text = 'text';
    static readonly media = 'image';
    static readonly player = 'player';
    static readonly tag = 'tag';
}

